import { render, staticRenderFns } from "./LandingPageCover.vue?vue&type=template&id=a2551032&scoped=true"
import script from "./LandingPageCover.vue?vue&type=script&lang=js"
export * from "./LandingPageCover.vue?vue&type=script&lang=js"
import style0 from "./LandingPageCover.vue?vue&type=style&index=0&id=a2551032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2551032",
  null
  
)

export default component.exports